import UIManager from './components/ui-manager';
import PaymentMethodHandler from './components/payment-method-handler';
import FormHandler from './components/form-handler';
import InstallmentsManager from './components/install-ments-manager';
import CouponManager from './components/coupon-manager';
import OrderTotalCalculator from './components/order-total-calculator';

export default class VindiOneClickBuy {
    constructor() {
        if (typeof vindiOneClick === 'undefined' || !vindiOneClick) {
            return;
        }

        this.modalSelector = '#vindi-one-click-modal';
        this.modal = jQuery(this.modalSelector);

        if (this.modal.length === 0) {
            return;
        }

        this.buyButton = jQuery('.vindi-one-click-buy');
        this.closeBtn = jQuery('.vindi-modal-close');
        this.processButton = jQuery('#vindi-process-quick-buy');

        this.uiManager = new UIManager(this.modalSelector);
        this.formHandler = new FormHandler();
        this.paymentHandler = new PaymentMethodHandler(this.modalSelector, this.uiManager);
        this.installmentsManager = new InstallmentsManager(this.modalSelector, this.uiManager);
        this.couponManager = new CouponManager(this, this.modalSelector, this.uiManager);
        this.orderTotalCalculator = new OrderTotalCalculator(this.modalSelector, this, this.uiManager);

        this.paymentHandler.onPaymentMethodChange = (token) => {
            this.installmentsManager.getInstallments(token);
        };

        this.init();
    }

    init() {
        this.bindEvents();
        this.uiManager.initUI();
        this.paymentHandler.initializeCreditCardHandling();
        this.paymentHandler.initializeCvvHandling();
        this.formHandler.initializePersonTypeHandling();
        this.formHandler.initializeCpfMask();
        this.installmentsManager.initializeInstallmentsHandling();
        this.orderTotalCalculator.initializeDiscountHandling();
        this.orderTotalCalculator.initializeQuantityHandling();
        this.couponManager.initializeCouponHandling();
    }

    bindEvents() {
        this.buyButton.on('click', (e) => {
            this.handleBuyButtonClick(e);
        });
        this.closeBtn.on('click', () => this.handleCloseModal());
        this.processButton.on('click', () => this.handleProcessPurchase());
    }

    handleBuyButtonClick(e) {
        e.preventDefault();

        const productId = this.buyButton.data('product-id');
        const productTitle = jQuery('h1.product_title').text();
        const productPrice = jQuery('.price .amount').text();

        this.uiManager.displayModal();
        this.uiManager.updateProductInfo(productTitle, productPrice);
    }

    handleCloseModal() {
        this.uiManager.hideModal();
    }

    handleProcessPurchase() {
        const processButton = this.processButton;
        const loadingSpinner = document.querySelector('.loading-spinner');

        processButton.prop('disabled', true);
        loadingSpinner.style.display = 'block';

        const billingValidation = this.formHandler.validateAndGetBillingData();
        if (!billingValidation.isValid) {
            alert(billingValidation.message);
            processButton.prop('disabled', false);
            loadingSpinner.style.display = 'none';
            return;
        }

        const paymentValidation = this.paymentHandler.validateAndGetPaymentData();
        if (!paymentValidation.isValid) {
            alert(paymentValidation.message);
            processButton.prop('disabled', false);
            loadingSpinner.style.display = 'none';
            return;
        }

        const productInfo = this.getProductInfo();

        jQuery.ajax({
            url: vindiOneClick.ajax_url,
            type: 'POST',
            data: {
                action: 'process_one_click_buy',
                nonce: vindiOneClick.nonce,
                product_id: productInfo.productId,
                quantity: productInfo.quantity,
                payment_method: paymentValidation.data.payment_method,
                card_data: paymentValidation.data.card_data,
                billing_data: billingValidation.data,
                coupon_codes: this.getAppliedCoupons()
            },
            success: (response) => {
                if (response.success) {
                    window.location.href = response.data.redirect;
                } else {
                    alert(response.data || 'Erro ao processar pagamento');
                    processButton.prop('disabled', false);
                    loadingSpinner.style.display = 'none';
                }
            },
            error: () => {
                alert('Erro ao processar pagamento. Por favor, tente novamente.');
                processButton.prop('disabled', false);
                loadingSpinner.style.display = 'none';
            }
        });
    }

    getProductInfo() {
        return {
            productId: this.buyButton.data('product-id'),
            quantity: parseInt(jQuery('#vindi-one-click-quantity').val() || 1)
        };
    }

    getAppliedCoupons() {
        return this.couponManager.getAppliedCoupons();
    }

    updateInstallmentsForSelectedPayment() {
        const selectedPaymentMethod = jQuery('input[name="payment_method"]:checked');

        if (selectedPaymentMethod.length && selectedPaymentMethod.val() === 'vindi-pagamentos-credit') {
            const tokenId = selectedPaymentMethod.data('token');

            if (tokenId) {
                this.installmentsManager.getInstallments(tokenId);
            } else {
                const cardBrand = jQuery('#wvp-card-brand').val();
                if (cardBrand) {
                    this.installmentsManager.getInstallments(null);
                }
            }
        }
    }

    onCouponApplied(data) {
        this.orderTotalCalculator.updateOrderTotals(data);
    }

    onCouponRemoved(data) {
        this.orderTotalCalculator.updateOrderTotals(data, true);
    }
}